import { copyrightUrlFragment, detoursUrlFragment, feedbackUrlFragment, getAllParts1, getCodeForAnyLang, getIntForAnyPartFragment, getRouteAndSegmentNumbers, landUrlFragment, legacyCopyrightUrlFragment, legacyDisclaimerUrlFragment, legacyFeedbackUrlFragment, legendUrlFragment, mapUrlFragment, oldOverlayDirectUrlFragment, overlayDirectUrlFragment, publishingCreditsUrlFragment, routeCategoriesUrlFragment, routeUrlFragment, seasonsUrlFragment, segmentUrlFragment, slowupLegendUrlFragment, legacyMediaUrlFragment, mediaUrlFragment, legacyChmServiceUrlFragment, chmServiceUrlFragment, legacyMobileUrlFragment, mobileUrlFragment, copyrightPhotoUrlFragment, toursUrlFragment, tourUrlFragment, recordedTourUrlFragment, } from './urlParams.js';
import { ROUTE_LAYERS } from '../layers/layerConstants.js';
import { languageCodes } from '../i18n.js';
import { selectedRoutes, selectedRoutesFilter } from './urlSelectedRoutes.js';
import { apiCodeToLandCode, isLandLayer, isSeasonCode, isLegacyUserLand, isAlternativeLandCode, landToLandCode, alternativeCodeToLandCode, isBgCode, } from '../layers/layerHelpers.js';
export const CANONICAL = Symbol('canonical');
export const PARTIAL = Symbol('partial');
export const FAILURE = Symbol('failure');
export const PageKind = {
    map: 'map',
    staticortopic: 'staticortopic',
    landlist: 'landlist',
    segment: 'segment',
    normallegend: 'normallegend',
    slowuplegend: 'slowuplegend',
    feedback: 'feedback',
    tours: 'tours',
    tour: 'tour',
    recordedtrack: 'recordedtrack',
    failure: 'failure',
};
export function removeLangFromUrlParts(pathNameSplit, searchParams, defaultLang, b2b = false) {
    const splitValue = pathNameSplit[0];
    const searchValue = searchParams.get('lang');
    searchParams.delete('lang');
    if (languageCodes.includes(splitValue)) {
        pathNameSplit.shift();
        if (b2b && splitValue === 'en')
            return 'de';
        return splitValue;
    }
    if (languageCodes.includes(searchValue)) {
        if (b2b && searchValue === 'en')
            return 'de';
        return searchValue;
    }
    return defaultLang;
}
export function splitPathName(pathname) {
    return pathname.split('/').filter((part) => part !== '');
}
export function normalizeURL(urlStr, defaultLang, defaultSeason, deployPrefix, b2b = false) {
    const url = new URL(urlStr);
    const pathNameSplit = splitPathName(url.pathname.substring(deployPrefix.length));
    const searchParams = url.searchParams;
    if (url.origin.match(/map.schweizmobil/)) {
        searchParams.set('redirect', 'map');
    }
    const lang = removeLangFromUrlParts(pathNameSplit, searchParams, defaultLang);
    if (searchParams.has('logo')) {
        searchParams.set('logos', searchParams.get('logo'));
        searchParams.delete('logo');
    }
    if (searchParams.has('highlight')) {
        searchParams.delete('highlight');
    }
    normalizeLayersParams(searchParams);
    const { code, bag, kind } = normalizeSplit(pathNameSplit, searchParams, lang, defaultSeason, b2b);
    if (code !== CANONICAL) {
        return {
            normalizedURL: url.toString(),
            detectedLang: lang,
            bag: bag,
            canonical: false,
            code: code,
            kind: kind,
        };
    }
    pathNameSplit.unshift(lang);
    url.pathname = `${deployPrefix}/${pathNameSplit.join('/')}`;
    const outUrl = url.toString();
    return {
        normalizedURL: outUrl,
        detectedLang: lang,
        bag,
        canonical: code === CANONICAL && !deployPrefix,
        code: code,
        kind: kind,
    };
}
function normalizeLayersParams(params) {
    const layers = params.has('layers') ? params.get('layers').split(',') : [];
    if (layers.includes('Accomodation')) {
        layers.splice(layers.indexOf('Accomodation'), 1, 'Accommodation');
    }
    if (layers.includes('Mountainbikeland')) {
        layers.splice(layers.indexOf('Mountainbikeland'), 1, 'Mtbland');
    }
    if (layers.includes('ch.swisstopo.swissboundaries3d-gemeinde-flaeche.fill')) {
        layers.splice(layers.indexOf('ch.swisstopo.swissboundaries3d-gemeinde-flaeche.fill'), 1, 'municipalities');
    }
    if (layers.includes('ch.swisstopo.swissboundaries3d-kanton-flaeche.fill')) {
        layers.splice(layers.indexOf('ch.swisstopo.swissboundaries3d-kanton-flaeche.fill'), 1, 'cantons');
    }
    if (layers.length > 0) {
        params.set('layers', layers.join(','));
    }
}
export function noHTML(str) {
    if (str && str.endsWith('.html')) {
        return str.substring(0, str.length - 5);
    }
    return str;
}
function normalizeSplit(pathNameSplit, searchParams, lang, defaultSeason, b2b) {
    const bag = {};
    bag.lang = lang;
    if (searchParams.has('embed')) {
        if (searchParams.get('embed') === 'simple')
            bag.embed = 'simple';
        else
            bag.embed = 'embed';
    }
    if (searchParams.has('trackId') || searchParams.has('recordedTrackId')) {
        let pageKind;
        if (searchParams.has('trackId')) {
            bag.trackId = searchParams.get('trackId');
            pageKind = PageKind.tour;
        }
        else {
            bag.recordedTrackId = searchParams.get('recordedTrackId');
            pageKind = PageKind.recordedtrack;
        }
        searchParams.delete('trackId');
        searchParams.delete('recordedTrackId');
        return { code: PARTIAL, bag, kind: pageKind };
    }
    if (searchParams.has('orte') || searchParams.has('place')) {
        bag.placeWebdbId = parseInt(searchParams.get('orte') || searchParams.get('place'), 10);
        searchParams.delete('orte');
        searchParams.delete('place');
        return { code: PARTIAL, bag, kind: PageKind.map };
    }
    if (searchParams.has('velorental') || searchParams.has('mietstation')) {
        bag.additionalLayerWebdbId = parseInt(searchParams.get('velorental') || searchParams.get('mietstation'), 10);
        bag.overlayType = 'velorental';
        searchParams.delete('velorental');
        searchParams.delete('mietstation');
        return { code: PARTIAL, bag, kind: PageKind.map };
    }
    if (searchParams.has('cycleservice') || searchParams.has('servicestelle')) {
        bag.additionalLayerWebdbId = parseInt(searchParams.get('cycleservice') || searchParams.get('servicestelle'), 10);
        bag.overlayType = 'cycleservice';
        searchParams.delete('cycleservice');
        searchParams.delete('servicestelle');
        return { code: PARTIAL, bag, kind: PageKind.map };
    }
    if (searchParams.has('accommodation') ||
        searchParams.has('uebernachten') ||
        searchParams.has('accomodation')) {
        bag.additionalLayerWebdbId = parseInt(searchParams.get('accommodation') ||
            searchParams.get('uebernachten') ||
            searchParams.get('accomodation'), 10);
        bag.overlayType = 'accommodation';
        searchParams.delete('accommodation');
        searchParams.delete('uebernachten');
        searchParams.delete('accomodation');
        return { code: PARTIAL, bag, kind: PageKind.map };
    }
    if (searchParams.has('swisspark')) {
        bag.additionalLayerWebdbId = parseInt(searchParams.get('swisspark'), 10);
        bag.overlayType = 'swisspark';
        searchParams.delete('swisspark');
        return { code: PARTIAL, bag, kind: PageKind.map };
    }
    if (searchParams.has('poi') || searchParams.has('sightseeing')) {
        bag.sightseeingId = parseInt(searchParams.get('poi') || searchParams.get('sightseeing'), 10);
        searchParams.delete('poi');
        searchParams.delete('sightseeing');
        return { code: PARTIAL, bag, kind: PageKind.map };
    }
    if (searchParams.has('vkpt') || searchParams.has('station')) {
        bag.stationId = parseInt(searchParams.get('vkpt') || searchParams.get('station'), 10);
        searchParams.delete('vkpt');
        searchParams.delete('station');
        return { code: PARTIAL, bag, kind: PageKind.map };
    }
    if (searchParams.has('slowup')) {
        const slowup = searchParams.get('slowup');
        searchParams.delete('slowup');
        if (slowup === 'all') {
            searchParams.set('layers', [...searchParams.getAll('layers'), 'slowup'].join(','));
        }
        else {
            bag.slowupId = parseInt(slowup, 10);
            return { code: PARTIAL, bag, kind: PageKind.map };
        }
    }
    if (searchParams.has('detour')) {
        bag.detourId = parseInt(searchParams.get('detour'), 10);
        searchParams.delete('detour');
        return { code: PARTIAL, bag, kind: PageKind.map };
    }
    if (pathNameSplit.length === 0 || pathNameSplit[0] === 'index.html') {
        pathNameSplit.length = 0;
        if (searchParams.has('resolution')) {
            const resolution = parseInt(searchParams.get('resolution'), 10);
            bag.neutralMapParams = {
                ...bag.neutralMapParams,
                resolution: resolution,
            };
        }
        if (searchParams.has('centerOnUser')) {
            bag.neutralMapParams = { ...bag.neutralMapParams, centerOnUser: true };
        }
        if ((searchParams.has('resolution') ||
            searchParams.has('centerOnUser') ||
            (searchParams.has('E') && searchParams.has('N')) ||
            (searchParams.has('X') && searchParams.has('Y')) ||
            (searchParams.has('lon_i') && searchParams.has('lat_i')) ||
            searchParams.has('layers') ||
            searchParams.has('season') ||
            searchParams.has('redirect') ||
            searchParams.has('bgLayer')) &&
            !searchParams.has('route') &&
            !searchParams.has('etappe')) {
            pathNameSplit.push(mapUrlFragment[lang]);
            return { code: CANONICAL, bag, kind: PageKind.map };
        }
        else if (searchParams.has('land') &&
            (searchParams.has('route') || searchParams.has('etappe'))) {
            const { land, route, etappe, season } = Object.fromEntries(searchParams);
            let routeNumber = Number(route);
            let segmentNumber = undefined;
            let landCode = undefined;
            if (isLandLayer(land)) {
                landCode = apiCodeToLandCode[land];
            }
            if (isLegacyUserLand(land)) {
                landCode = landToLandCode[land];
            }
            if (isAlternativeLandCode(land)) {
                landCode = alternativeCodeToLandCode[land];
            }
            if (landCode && (route || etappe)) {
                bag.land = landCode;
                if (etappe) {
                    const numbers = etappe.split('.').map((n) => Number(n));
                    if (!isNaN(numbers[0]))
                        routeNumber = numbers[0];
                    if (!isNaN(numbers[1]))
                        segmentNumber = numbers[1];
                }
                bag.routeNumber = routeNumber;
                bag.segmentNumber = segmentNumber;
                pathNameSplit[0] = landUrlFragment[landCode][lang];
                pathNameSplit[1] = `${routeUrlFragment[lang]}-${routeNumber}`;
                if (segmentNumber)
                    pathNameSplit[2] = `${segmentUrlFragment[lang]}-${segmentNumber}`;
            }
            if (isSeasonCode(season)) {
                bag.season = season;
            }
            else if (land && ROUTE_LAYERS[landCode]) {
                bag.season = ROUTE_LAYERS[landCode].season;
            }
            searchParams.set('focus', 'map');
            return { code: CANONICAL, bag, kind: PageKind.segment };
        }
        else {
            if (b2b) {
                bag.staticOrTopicKey = 'b2b_landpages';
                return {
                    code: CANONICAL,
                    bag,
                    kind: PageKind.staticortopic,
                };
            }
            pathNameSplit[0] = seasonsUrlFragment[defaultSeason][lang];
            bag.season = defaultSeason;
            return { code: CANONICAL, bag, kind: PageKind.landlist };
        }
    }
    const firstPart = noHTML(pathNameSplit[0]);
    const lastPart = noHTML(pathNameSplit.at(-1));
    const secondLastPart = noHTML(pathNameSplit.at(-2));
    if (getAllParts1(mapUrlFragment).includes(firstPart)) {
        if (pathNameSplit.length !== 1) {
            return { code: FAILURE, bag, kind: PageKind.failure };
        }
        pathNameSplit[0] = mapUrlFragment[lang];
        const { bgLayer, fitBbox, season, detours, shooting, photos, logos, crosshair, land, route, etappe, } = Object.fromEntries(searchParams);
        bag.neutralMapParams = {
            bgLayer: isBgCode(bgLayer) ? bgLayer : undefined,
            fitBbox: !!fitBbox,
            logos: !logos || logos === 'yes',
            detours: !detours || detours === 'yes',
            photos: !photos || photos === 'yes',
            crosshair: crosshair,
            shooting: !shooting || shooting === 'yes',
            keepLayers: searchParams.has('keepLayers'),
            centerOnUser: searchParams.has('centerOnUser'),
        };
        let routeNumber = Number(route);
        let segmentNumber = 0;
        let landCode = undefined;
        if (isLandLayer(land)) {
            landCode = apiCodeToLandCode[land];
        }
        if (isLegacyUserLand(land)) {
            landCode = landToLandCode[land];
        }
        if (isAlternativeLandCode(land)) {
            landCode = alternativeCodeToLandCode[land];
        }
        if (landCode && (route || etappe)) {
            bag.land = landCode;
            if (etappe) {
                const numbers = etappe.split('.').map((n) => Number(n));
                if (!isNaN(numbers[0]))
                    routeNumber = numbers[0];
                if (!isNaN(numbers[1]))
                    segmentNumber = numbers[1];
            }
            bag.routeNumber = routeNumber;
            bag.segmentNumber = segmentNumber;
        }
        if (isSeasonCode(season)) {
            bag.season = season;
        }
        else if (landCode && ROUTE_LAYERS[landCode]) {
            bag.season = ROUTE_LAYERS[landCode].season;
        }
        return { code: CANONICAL, bag, kind: PageKind.map };
    }
    if (getAllParts1(toursUrlFragment).includes(firstPart)) {
        if (pathNameSplit.length !== 1) {
            return { code: FAILURE, bag, kind: PageKind.failure };
        }
        pathNameSplit[0] = toursUrlFragment[lang];
        return { code: CANONICAL, bag, kind: PageKind.tours };
    }
    if (getAllParts1(tourUrlFragment).includes(firstPart)) {
        pathNameSplit[0] = tourUrlFragment[lang];
        const tourId = parseInt(pathNameSplit[1], 10);
        if (pathNameSplit.length === 2 || !Number.isNaN(tourId)) {
            bag.tourId = tourId;
        }
        if (searchParams.has('season') &&
            isSeasonCode(searchParams.get('season'))) {
            bag.season = searchParams.get('season');
        }
        return { code: CANONICAL, bag, kind: PageKind.tour };
    }
    if (getAllParts1(recordedTourUrlFragment).includes(firstPart)) {
        pathNameSplit[0] = recordedTourUrlFragment[lang];
        const tourId = parseInt(pathNameSplit[1], 10);
        if (pathNameSplit.length === 2 && !Number.isNaN(tourId)) {
            bag.tourId = tourId;
        }
        return { code: CANONICAL, bag, kind: PageKind.recordedtrack };
    }
    if (getAllParts1(legendUrlFragment).includes(firstPart)) {
        pathNameSplit[0] = legendUrlFragment[lang];
        return { code: CANONICAL, bag, kind: PageKind.normallegend };
    }
    if (getAllParts1(slowupLegendUrlFragment).includes(firstPart)) {
        pathNameSplit[0] = slowupLegendUrlFragment[lang];
        return { code: CANONICAL, bag, kind: PageKind.slowuplegend };
    }
    if (firstPart.includes('unterseiten') ||
        getAllParts1(legacyDisclaimerUrlFragment).includes(firstPart)) {
        pathNameSplit[0] = detoursUrlFragment[lang];
        bag.staticOrTopicKey = detoursUrlFragment[lang];
        pathNameSplit.length = 1;
        return { code: CANONICAL, bag, kind: PageKind.staticortopic };
    }
    if (getAllParts1(legacyMediaUrlFragment).includes(firstPart)) {
        pathNameSplit[0] = mediaUrlFragment[lang];
        bag.staticOrTopicKey = mediaUrlFragment[lang];
        return { code: CANONICAL, bag, kind: PageKind.staticortopic };
    }
    if (getAllParts1(legacyChmServiceUrlFragment).includes(firstPart)) {
        pathNameSplit[0] = chmServiceUrlFragment[lang];
        bag.staticOrTopicKey = chmServiceUrlFragment[lang];
        return { code: CANONICAL, bag, kind: PageKind.staticortopic };
    }
    if (getAllParts1(legacyMobileUrlFragment).includes(firstPart)) {
        pathNameSplit[0] = mobileUrlFragment[lang];
        bag.staticOrTopicKey = mobileUrlFragment[lang];
        return { code: CANONICAL, bag, kind: PageKind.staticortopic };
    }
    if (getAllParts1(copyrightPhotoUrlFragment).includes(firstPart)) {
        pathNameSplit[0] = copyrightPhotoUrlFragment[lang];
        bag.staticOrTopicKey = copyrightPhotoUrlFragment[lang];
        return { code: CANONICAL, bag, kind: PageKind.staticortopic };
    }
    if (firstPart === 'impressum' ||
        getAllParts1(publishingCreditsUrlFragment).includes(firstPart)) {
        pathNameSplit[0] = publishingCreditsUrlFragment[lang];
        bag.staticOrTopicKey = publishingCreditsUrlFragment[lang];
        return { code: CANONICAL, bag, kind: PageKind.staticortopic };
    }
    if (firstPart === 'feedback' ||
        getAllParts1(legacyFeedbackUrlFragment).includes(firstPart)) {
        pathNameSplit[0] = feedbackUrlFragment;
        return { code: CANONICAL, bag, kind: PageKind.feedback };
    }
    if (getAllParts1(legacyCopyrightUrlFragment).includes(firstPart)) {
        pathNameSplit[0] = copyrightUrlFragment;
        bag.staticOrTopicKey = copyrightUrlFragment;
        return { code: CANONICAL, bag, kind: PageKind.staticortopic };
    }
    if (firstPart === 'qrcode') {
        pathNameSplit[0] = 'map';
        return { code: CANONICAL, bag, kind: PageKind.map };
    }
    const seasonCode = getCodeForAnyLang(firstPart, seasonsUrlFragment);
    if (seasonCode) {
        if (pathNameSplit.length !== 1) {
            return { code: FAILURE, bag, kind: PageKind.failure };
        }
        pathNameSplit[0] = seasonsUrlFragment[seasonCode][lang];
        bag.season = seasonCode;
        return { code: CANONICAL, bag, kind: PageKind.landlist };
    }
    const landCode = getCodeForAnyLang(firstPart, landUrlFragment);
    if (landCode) {
        pathNameSplit[0] = landUrlFragment[landCode][lang];
        bag.land = landCode;
        bag.season = ROUTE_LAYERS[landCode].season;
        if (pathNameSplit.length === 1) {
            return { code: CANONICAL, bag, kind: PageKind.landlist };
        }
        const routeCategoryCode = getCodeForAnyLang(lastPart, routeCategoriesUrlFragment);
        if (routeCategoryCode) {
            pathNameSplit[1] = routeCategoriesUrlFragment[routeCategoryCode][lang];
            pathNameSplit.length = 2;
            bag.routeCategory = routeCategoryCode;
            return { code: CANONICAL, bag, kind: PageKind.landlist };
        }
        const routeSegmentNb = getRouteAndSegmentNumbers(lastPart);
        if (routeSegmentNb) {
            const routeNb = routeSegmentNb[0];
            const segmentNb = routeSegmentNb[1];
            bag.routeNumber = routeNb;
            pathNameSplit[1] = `${routeUrlFragment[lang]}-${routeNb}`;
            bag.segmentNumber = segmentNb;
            pathNameSplit[2] = `${segmentUrlFragment[lang]}-${segmentNb}`;
            pathNameSplit.length = 3;
            return { code: CANONICAL, bag, kind: PageKind.segment };
        }
        const routeNb = getIntForAnyPartFragment(lastPart, routeUrlFragment);
        if (routeNb) {
            pathNameSplit[1] = `${routeUrlFragment[lang]}-${routeNb}`;
            pathNameSplit.length = 2;
            bag.routeNumber = routeNb;
            return { code: CANONICAL, bag, kind: PageKind.segment };
        }
        const segmentNb = getIntForAnyPartFragment(lastPart, segmentUrlFragment);
        if (segmentNb) {
            const routeNb = getIntForAnyPartFragment(secondLastPart, routeUrlFragment);
            if (routeNb) {
                bag.routeNumber = routeNb;
                bag.segmentNumber = segmentNb;
                pathNameSplit[1] = `${routeUrlFragment[lang]}-${routeNb}`;
                pathNameSplit[2] = `${segmentUrlFragment[lang]}-${segmentNb}`;
                pathNameSplit.length = 3;
                return { code: CANONICAL, bag, kind: PageKind.segment };
            }
            else {
                bag.segmentWebdbId = segmentNb;
                return { code: PARTIAL, bag, kind: PageKind.segment };
            }
        }
        const selectedRoutesCode = getCodeForAnyLang(lastPart, selectedRoutes);
        if (selectedRoutesCode) {
            pathNameSplit[0] = bag.season;
            pathNameSplit.length = 1;
            searchParams.set('filters', JSON.stringify(selectedRoutesFilter[selectedRoutesCode]));
            return { code: CANONICAL, bag, kind: PageKind.segment };
        }
    }
    const layerPartSplit = lastPart.split(/-(?:sr)?(\d+)/);
    if (oldOverlayDirectUrlFragment['travelreport'][lang] === layerPartSplit[0]) {
        const routeNb = parseInt(layerPartSplit[1], 10);
        if (Number.isNaN(routeNb)) {
            pathNameSplit.length = 1;
        }
        else {
            bag.routeNumber = routeNb;
            pathNameSplit[1] = `${routeUrlFragment[lang]}-${routeNb}`;
            pathNameSplit.length = 2;
        }
        return { code: CANONICAL, bag, kind: PageKind.segment };
    }
    if (secondLastPart === 'rkey') {
        bag.placeWebdbId = parseInt(layerPartSplit[0], 10);
        return { code: PARTIAL, bag, kind: PageKind.map };
    }
    if (secondLastPart === oldOverlayDirectUrlFragment['travelreport'][lang]) {
        const oldId = lastPart.match(/\d+/)[0];
        const newId = oldId.length > 4 ? parseInt(oldId.substring(2), 10) : parseInt(oldId, 10);
        pathNameSplit[1] = `${overlayDirectUrlFragment['travelreport'][lang]}-${newId}`;
        pathNameSplit.length = 2;
        return { code: CANONICAL, bag, kind: PageKind.landlist };
    }
    if (secondLastPart === 'poi') {
        const layerId = parseInt(layerPartSplit[0], 10);
        return normalizePoiUrl(pathNameSplit, lang, bag, 'sightseeing', layerId);
    }
    const layerCode = getCodeForAnyLang(layerPartSplit[0], overlayDirectUrlFragment);
    const layerId = parseInt(layerPartSplit[1]);
    if (isNaN(layerId)) {
        bag.staticOrTopicKey = firstPart;
        return { code: CANONICAL, bag, kind: PageKind.staticortopic };
    }
    return normalizePoiUrl(pathNameSplit, lang, bag, layerCode, layerId);
}
function normalizePoiUrl(pathNameSplit, lang, bag, layerCode, layerId) {
    if (layerCode === undefined) {
        return { code: FAILURE, bag, kind: PageKind.map };
    }
    const index = layerCode === 'travelreport' ? 1 : 0;
    pathNameSplit[index] =
        `${overlayDirectUrlFragment[layerCode][lang]}-${layerId}`;
    pathNameSplit.length = index + 1;
    bag.overlayType = layerCode;
    bag.overlayContentId = layerId;
    return { code: CANONICAL, bag, kind: PageKind.map };
}
export function normalizeB2bUrl(urlStr, deployPrefix, defaultLang) {
    const url = new URL(urlStr);
    const pathNameSplit = splitPathName(url.pathname.substring(deployPrefix.length));
    const searchParams = url.searchParams;
    const lang = removeLangFromUrlParts(pathNameSplit, searchParams, defaultLang, true);
    pathNameSplit.unshift(lang);
    url.pathname = `${deployPrefix}/${pathNameSplit.join('/')}`;
    return url.toString();
}
//# sourceMappingURL=urlNormalizer.js.map